import React from 'react';
import Box from '@mui/material/Box';
import { Credit } from '@elevator/ui';
import CreditChip from 'atoms/CreditChip';
import useStyles from './styles';

/**
 * CreditGrid Component
 *
 * Displays a horizontal grid of credit chips using CreditChip components.
 * Used to show credits (artists, producers, directors, etc.) on published posts.
 *
 * Renders credits in a flexbox row layout with consistent spacing between chips.
 * Handles both user credits (with avatar and navigation) and non-user credits.
 *
 * @param props - Component props
 * @param props.credits - Array of Credit objects to display
 */
const CreditGrid = (props: CreditGridProps) => {
  const { credits } = props;
  const { classes } = useStyles();

  if (!credits?.length) {
    return null;
  }

  return (
    <Box className={classes.root} data-component="CreditGrid">
      {credits.map((credit, index) => {
        const name = credit.user
          ? credit.user.displayName || credit.user.preferredUsername
          : credit.name;
        return (
          <CreditChip
            key={credit.creditId || `credit-${index}`}
            variant={'view'}
            type={credit.creditType.typeName}
            name={name}
            avatar={credit.user?.avatar}
            preferredUsername={credit.user?.preferredUsername}
          />
        );
      })}
    </Box>
  );
};

/**
 * Props for the CreditGrid component
 */
export type CreditGridProps = {
  /** Array of Credit objects to display */
  credits: Credit[];
};

export default CreditGrid;
